import type { ComplianceMonitoringAssessmentTestResultsByControlIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetOversightAssessmentTestResultsByControlIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetOversightAssessmentTestResultsByControlIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetOversightAssessmentTestResultsByControlIdArgs = {
  controlId: string;
};

export const useGetOversightAssessmentTestResultsByControlId = createQueryHook<
  UseGetOversightAssessmentTestResultsByControlIdArgs,
  ComplianceMonitoringAssessmentTestResultsByControlIdResponseRow[],
  GetOversightAssessmentTestResultsByControlIdQuery
>({
  trpcQueryOptions: (trpc, { controlId }) =>
    trpc.frontend.testResult.complianceMonitoringAssessmentTestResultsByControlId.queryOptions(
      {
        controlId,
      }
    ),
  mapTrpcDataToGraphQL: (data) =>
    ({
      control_test_oversight_result: data,
    }) as unknown as GetOversightAssessmentTestResultsByControlIdQuery,
  graphqlDocument: GetOversightAssessmentTestResultsByControlIdDocument,
  graphqlVariables: ({ controlId }) => ({ controlId }),
});
